/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User's self-report of what a power-on session (run) is for.
 * 
 * Recorded on every answer, including changes; the server treats the
 * latest event per run as authoritative (latest answer wins). Mirrored
 * on the device in salmon/src/kodiak/events.py.
 * @export
 * @interface SessionIntentPayload
 */
export interface SessionIntentPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: SessionIntentPayloadTypeEnum;
    /**
     * 
     */
    intent: SessionIntentPayloadIntentEnum;
    /**
     * 
     */
    previousIntent?: string | null;
}


/**
 * @export
 */
export const SessionIntentPayloadTypeEnum = {
    SessionIntent: 'session_intent',
} as const;
export type SessionIntentPayloadTypeEnum = typeof SessionIntentPayloadTypeEnum[keyof typeof SessionIntentPayloadTypeEnum];

/**
 * @export
 */
export const SessionIntentPayloadIntentEnum = {
    Fishing: 'fishing',
    Testing: 'testing',
} as const;
export type SessionIntentPayloadIntentEnum = typeof SessionIntentPayloadIntentEnum[keyof typeof SessionIntentPayloadIntentEnum];


/**
 * Check if a given object implements the SessionIntentPayload interface.
 */
export function instanceOfSessionIntentPayload(value: object): value is SessionIntentPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'session_intent') return false;
    
    if (!('intent' in value) || value['intent'] === undefined) return false;
    return true;
}

export function SessionIntentPayloadFromJSON(json: any): SessionIntentPayload {
    return SessionIntentPayloadFromJSONTyped(json, false);
}

export function SessionIntentPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionIntentPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'intent': json['intent'],
        'previousIntent': json['previous_intent'] === undefined ? undefined : json['previous_intent'] === null ? null : json['previous_intent'],
    };
}

export function SessionIntentPayloadToJSON(json: any): SessionIntentPayload {
    return SessionIntentPayloadToJSONTyped(json, false);
}

export function SessionIntentPayloadToJSONTyped(value?: SessionIntentPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'intent': value['intent'],
        'previous_intent': value['previousIntent'],
    };
}

